<template>
  <div class="main-content">
    <div class="card">
      <div class="card-header">
        <h5>Авторизация</h5>
      </div>
      <div class="card-body">
        {{ $route.query.imei }}
        <form @submit.prevent="auth">
          <div class="mb-3">
            <label for="exampleInputPassword1" class="form-label">Пароль</label>
            <input v-model="pass" type="password" class="form-control" id="exampleInputPassword1">
          </div>
          <div class="text-center">
            <LoadingButton
              title="Вход"
              :loading="loading"
              color="#4fc47f"
              :onClick="() => auth()"
              className="btn btn-info"
            />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";
import axios from "axios";
import Ls from "@/services/ls";

export default {
  components: {
    LoadingButton,
  },
  data() {
    return {
      loading: false,
      pass: null,
    }
  },
  methods: {
    async auth() {
      if (!this.pass || this.loading) return;
      this.loading = true;
      const {data} = await axios.post('/api/auth/tabletLogin', {
        pass: this.pass,
        imei: this.$route.query.imei
      })
      if (data.success) {
        Ls.set('auth.token', data.token);
        Ls.set('api-token', data.api_token);
        this.mixinGoToRouter('TabletMyOrders');
      } else {
        toastr["warning"](data.message || "Нет доступа", "Ошибка");
        this.loading = false;
      }
    },
  }
}
</script>


<style scoped>
.draw {
  width: 100%;
}
</style>
